/**
 * Farmland's Samples read (FLF-S6, FWINT-S5): the lots this tenant holds on H.Release that are still awaiting a pass, with
 * when each went on hold and its status (Awaiting result, Fail, Overdue or Unrecognised). A lot whose latest confirmed
 * review is a Pass is not listed.
 *
 * Follows `acceptanceReferences.ts`'s own shape: a named function plus a query-key factory, typed off
 * `./generated/coaApi.js`.
 */
import { coaListParams } from './coaLists.js';
/**
 * Query keys as a factory rather than as literals at each call site, on `coaQueryKeys`'s own convention in
 * `acceptanceReferences.ts` (kept as its own small factory here since this file has no dependency on that
 * one beyond the shared {@link CoaTransport} type).
 */
export const coaLotOnHoldReleaseQueryKeys = {
    lotsOnHoldRelease: () => ['module', 'coa', 'lots-on-hold-release'],
    /** The key the Samples page's interactive list caches each view under: a sub-key of the base key, so one invalidation refreshes every view. */
    lotsOnHoldReleaseList: () => [...coaLotOnHoldReleaseQueryKeys.lotsOnHoldRelease(), 'list'],
    /** The Overview's Overdue figure: a sub-key of the base key, so one invalidation refreshes it too. */
    overdueLots: () => [...coaLotOnHoldReleaseQueryKeys.lotsOnHoldRelease(), 'overdue-lots'],
};
/**
 * Reads this tenant's lots awaiting a pass. With no `query` it asks for the default view,
 * oldest observed first, with no query string, which is what the Overview figure used to send. With one it asks for a page on the
 * shared list contract.
 */
export function listLotsOnHoldRelease(transport, options) {
    return transport.send({
        method: 'GET',
        path: '/v1/coa/lots-on-hold-release',
        ...coaListParams(options?.query),
        ...(options?.signal === undefined ? {} : { signal: options.signal }),
    });
}
/**
 * The Overview's Overdue figure read: the Samples endpoint filtered to the Overdue status (`status:in:overdue`, FLF-S87).
 * Its `totalCount` is the whole overdue total, so the figure is not capped at the first page of rows.
 */
export function overdueLotsQueryOptions(transport) {
    return {
        queryKey: coaLotOnHoldReleaseQueryKeys.overdueLots(),
        queryFn: (context) => listLotsOnHoldRelease(transport, { query: { filter: ['status:in:overdue'] }, signal: context.signal }),
    };
}
//# sourceMappingURL=lotsOnHoldRelease.js.map